import { getAuthors, postAuthor, putAuthor } from "../../api/authors";
import { createSliceWithThunks } from "../utils";

const initialState = {
  get: {
    list: null,
    status: "idle",
    error: null,
  },
  post: {
    data: null,
    status: "idle",
    error: null,
  },
  put: {
    data: null,
    status: "idle",
    error: null,
  },
};

export const authorSlice = createSliceWithThunks({
  name: "authors",
  initialState: initialState,
  reducers: (create) => ({
    resetStateAuthors: create.reducer((state, { payload }) => {
      if (payload) {
        for (let key in payload) {
          state[`${payload[key]}`] = initialState[`${payload[key]}`];
        }
      } else {
        for (let key in initialState) {
          state[key] = initialState[key];
        }
      }
    }),
    //* thunks
    fetchAuthors: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getAuthors(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.get.status = "loading";
        },

        rejected: (state, action) => {
          state.get.status = "failed";
          state.get.error = action.error;
        },

        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.get.error = { message: respObj };
            } else if (status === "success") {
              state.get.list = respObj;
            }
          } else {
            state.get.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.get.status = "idle";
        },
      }
    ),
    addNewAuthor: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postAuthor(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.post.status = "loading";
        },
        rejected: (state, action) => {
          state.post.status = "failed";
          state.post.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.post.error = { message: respObj };
            } else if (status === "success") {
              state.post.data = respObj;
            }
          } else {
            state.post.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.post.status = "idle";
        },
      }
    ),
    updateAuthor: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await putAuthor(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.put.status = "loading";
        },
        rejected: (state, action) => {
          state.put.status = "failed";
          state.put.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.put.error = { message: respObj };
            } else if (status === "success") {
              state.put.data = respObj;
            }
          } else {
            state.put.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.put.status = "idle";
        },
      }
    ),
  }),
});

export const { fetchAuthors, addNewAuthor, updateAuthor, resetStateAuthors } =
  authorSlice.actions;
export default authorSlice.reducer;
